import { render } from "./BasicAlerts.vue?vue&type=template&id=3af1360e"
import script from "./BasicAlerts.vue?vue&type=script&lang=js"
export * from "./BasicAlerts.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__